import _ from "lodash";
import React, { Component, ReactDOM } from "react";
import PropTypes from "prop-types";
import { RadioGroup } from "react-spark";

import {
  checkboxAndRadioOptionsPropTypes,
  withValidationOutputDefaultProps,
  withValidationOutputPropTypes,
  sharedFormInputPropTypes,
  sharedFormInputDefaultProps
} from "../hocs/prop-types";
import { withValidation } from "../hocs/WithValidation";
import helpers from "../../../helpers";

const { titleCase } = helpers.filters;
class URCRadio extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { name } = this.props;
    this.props.context.registerFormElement({
      value: this.props.value,
      name,
      valid: this.props.validateOnRegisterUpdate.apply(this),
      validate: this.props.handleValidation
    });
  }

  componentDidUpdate() {
    const { name } = this.props;
    if (this.props.forceUpdate) {
      this.props.context.updateFormElement({
        value: this.props.value,
        name,
        valid: !this.props.validateOnRegisterUpdate.apply(this)
      });
    }
  }

  componentWillUnmount() {
    this.props.context.deregisterFormElement({
      name: this.props.name,
    }, this);
  }

  cleanOptions(options) {
    return options.map(o => {
      const option = Object.assign({}, o);

      if (_.isNil(option.label)) {
        option.label = titleCase(o.value);
      }

      return option;
    });
  }

  isValid() {
    const { context, id, validation } = this.props;
    const isValidCheckbox = validation.required
      ? _.get(context.elements, `${id}.value`)
      : true;
    return isValidCheckbox;
  }

  render() {
    const {
      className,
      context,
      disabled,
      errorMessage,
      handleChange,
      label,
      name,
      parentContainerClassName,
      value
    } = this.props;
    const options = this.cleanOptions(this.props.options);
    
    return (
      <RadioGroup
        className={className}
        parentContainerClassName={parentContainerClassName}
        disabled={disabled}
        error={errorMessage}
        id={name}
        label={label}
        name={name}
        onChange={event => handleChange(event, context)}
        radios={options}
        value={value}
      />
    );
  }
}

URCRadio.defaultProps = {
  ...withValidationOutputDefaultProps,
  ...sharedFormInputDefaultProps,
  label: "",
  value: "",
  parentContainerClassName: ""
};

URCRadio.propTypes = {
  ...checkboxAndRadioOptionsPropTypes,
  ...withValidationOutputPropTypes,
  ...sharedFormInputPropTypes,
  label: PropTypes.node,
  value: PropTypes.node,
  parentContainerClassName: PropTypes.string
};

export default withValidation(URCRadio, { type: "radio" });
